module.exports = __webpack_public_path__ + "static/J2021_CM_abs-fda4a20d4d7a0e39e5969dcce37a6030.gif";